module.exports = __webpack_public_path__ + "static/media/issue4.56203fb2.webp";